// extracted by mini-css-extract-plugin
module.exports = {"container":"bRaY5dtPJh1H4yEqWxpXS"};